/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
import LoadJS from 'load-js'

import CreateCustomMarker from './CustomGoogleMapMarker'

import {IsIsset} from "helpers/ValueTests";

import './style'
import './media'

const styles = [
    { "featureType":"administrative", "elementType":"all", "stylers": [{ "visibility":"on"}, { "saturation":-100}, { "lightness": 20 }]},
    { "featureType": "road", "elementType": "all", "stylers": [{ "visibility": "on" }, { "saturation": -100 }, { "lightness": 40 }] },
    { "featureType": "water", "elementType": "all", "stylers": [{ "visibility": "on" }, { "saturation": -10 }, { "lightness": 30 }] },
    { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "saturation": -60 }, { "lightness": 10 }] },
    { "featureType": "landscape.natural", "elementType": "all", "stylers": [{ "visibility": "simplified" }, { "saturation": -60 }, { "lightness": 60 }] },
    { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }, { "saturation": -100 }, { "lightness": 60 }] },
    { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }, { "saturation": -100 }, { "lightness": 60 }] }
    ]


class MapClinic extends React.PureComponent{
    defMapParams = {
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        zoomControl: false,
        styles,
        gestureHandling: "greedy"
    }

    loadJS = () => {
        console.log("[GoogleMaps][loadJS]")

        const API_KEY ="AIzaSyAQWJNQSTl4RS0pAsypWDDjZfbf6NmDMCQ"

        return LoadJS([{
            async: true,
            url: `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`
        }])
    }

    componentDidMount() {
        this.initializeMap()
    }

    initializeMap = async () => {
        if(!IsIsset(window.google)){
            await this.loadJS()
        }

        if (!this.CustomMarker) this.CustomMarker = CreateCustomMarker(window.google)

        this.initMap()
    }

    waitFullLoadMap = () => new Promise(ok => {
        console.log("[GoogleMaps][waitFullLoadMap]")

        window.google.maps.event.addListenerOnce(this.map, 'idle', ok )
    })

    async initMap(){
        const {
            name = "",
            lng = 37.5880159,
            lat = 55.7441462,
        } = this.props

        let clinic = { lat: parseFloat(lat), lng: parseFloat(lng) }

        const mapParams = {
            ...this.defMapParams,
            center: clinic,
            zoom: 18
        }

        this.map = new window.google.maps.Map(
            document.getElementById('map'),
            mapParams
        )

        await this.waitFullLoadMap()

        /*const markerParams = {
            position: clinic,
            map: this.map,
            title: name
        }

        this.marker = new window.google.maps.Marker( markerParams )*/

        const position = new window.google.maps.LatLng(lat, lng)

        new this.CustomMarker(
            position,
            this.map,
            {
                id: lng,
                label: name
            }
        )
    }

    render() {
        const { props } = this

        return (
            <div className={c("map-clinic", props.className)}>
                <div id='map' />
            </div>
        );
    }
}

/*const MapClinicMarker = props => (
    <div className={c("map-clinic-marker", props.className)}>
        <Img src={MapMarkerIcon} className="clinic__marker"/>      
        {props.name}
    </div>
) */

/*export { MapClinicMarker } */
export default MapClinic